export default __webpack_public_path__ + "static/m-office-0d08bb007136ad868bebcca18f03397b.jpg";